// extracted by mini-css-extract-plugin
module.exports = {"share":"ShareContent_share__Y2cFk","shareButtons":"ShareContent_shareButtons__VXkP6"};